<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        @if(!isEcommerceUser){
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/sp">
            <img src="./assets/img/logos/logoAvancemos.png" alt="Logo" class="h-10 w-auto" />
        </a>
        }
        @if(isEcommerceUser){
        <a class="layout-topbar-logo" routerLink="/sp/ec/view">
            <img src="./assets/img/logos/logoAvancemos.png" alt="Logo" class="h-10 w-auto" />
        </a>
        }
    </div>
    <!-- Usuario en el centro -->
    <div class="layout-topbar-center">
        <div class="user-info">
            <i class="pi pi-user"></i>
            <span class="user-name">{{ nombreUsuario }}</span>
        </div>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            <app-configurator />
            <!-- </div> -->
        </div>

        <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden"
            enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
                <a href="https://wa.link/3k7oi1" target="_blank"><button type="button" style="color: green;"
                        class="layout-topbar-action" pTooltip="WhatsApp" tooltipPosition="left">
                        <i class="pi pi-whatsapp"></i>
                        <span>Favoritos</span>
                    </button></a>
                <button type="button" class="layout-topbar-action" pTooltip="E-Commerce" tooltipPosition="left"
                    (click)="goto('/sp/ec/view')">
                    <i class="pi pi-shopping-bag"></i>
                    <span>Ecommerce</span>
                </button>
                <button type="button" class="layout-topbar-action" pTooltip="Carrito Compras" tooltipPosition="left"
                    (click)="goto('/sp/ec/cart')">
                    <i class="pi pi-shopping-cart"></i>
                    <span>Carrito</span>
                </button>

                <!-- <button type="button" class="layout-topbar-action" pTooltip="Calendario" tooltipPosition="left">
                    <i class="pi pi-calendar"></i>
                    <span>Calendar</span>
                </button> -->
                <!-- <button type="button" class="layout-topbar-action" pTooltip="Mensajes" tooltipPosition="left">
                    <i class="pi pi-inbox"></i>
                    <span>Messages</span>
                </button> -->
                <button type="button" class="layout-topbar-action" pTooltip="Perfil" tooltipPosition="left"
                    (click)="goto('/sp/ec/profile')">
                    <i class="pi pi-user"></i>
                    <span>Pefil</span>
                </button>
                <button type="button" class="layout-topbar-action" pTooltip="Salir" tooltipPosition="left"
                    (click)="openConfirmation()">
                    <i class="pi pi-fw pi-sign-out"></i>
                    <span>Salir</span>
                </button>
            </div>
        </div>
    </div>
</div>

<p-dialog header="Confirmación" [(visible)]="displayConfirmation" [style]="{ width: '350px' }" [modal]="true">
    <div class="flex items-center justify-center">
        <i class="pi pi-exclamation-triangle mr-4" style="font-size: 2rem"> </i>
        <span>¿Esta seguro que desea cerrar la sesión?</span>
    </div>
    <ng-template #footer>
        <p-button label="No" icon="pi pi-times" (click)="closeConfirmation(false)" text severity="danger" />
        <p-button label="Si" icon="pi pi-check" (click)="closeConfirmation(true)" severity="success" outlined
            autofocus />
    </ng-template>
</p-dialog>